import React from 'react';
import './Sidebar.css';

function Sidebar({ collapsed, setCollapsed, activePage, setActivePage }) {
    const sidebarLinks = [
        { id: 'what-is-goloka', label: 'What is Goloka Dham', icon: '🌟' },
        { id: 'how-to-reach', label: 'How to Reach Goloka Dham', icon: '🛤️' }
    ];

    return (
        <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
            <button
                className="collapse-btn"
                onClick={() => setCollapsed(!collapsed)}
                title={collapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
            >
                {collapsed ? '☰' : '✕'}
            </button>

            {!collapsed && (
                <div className="sidebar-content">
                    <h3 className="sidebar-title">Navigation</h3>
                    <div className="sidebar-links">
                        {sidebarLinks.map(link => (
                            <button
                                key={link.id}
                                className={`sidebar-link ${activePage === link.id ? 'active' : ''}`}
                                onClick={() => setActivePage(link.id)}
                            >
                                <span className="sidebar-icon">{link.icon}</span>
                                <span className="sidebar-label">{link.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Sidebar;
